const FOUNTAIN_HOSTNAME = "fountain.com";

/**
 * Determines whether an absolute URL points to Fountain.
 * Used to scope tracking-parameter forwarding (e.g. gclid) to Fountain job
 * application URLs only, since other job application destinations aren't
 * known to expect or forward those parameters.
 */
function isFountainUrl(url: string | undefined): boolean {
  if (!url) {
    return false;
  }

  try {
    const { hostname } = new URL(url);
    return (
      hostname === FOUNTAIN_HOSTNAME ||
      hostname.endsWith(`.${FOUNTAIN_HOSTNAME}`)
    );
  } catch {
    return false;
  }
}

export { isFountainUrl };
